/**
 * @desc H5门店下单检查
 */

import { RequestConfig, request } from 'umi';
export interface Params {
  /** phone */
  phone: string;
  /** token */
  token: string;
}

function req(params: Params, config: Parameters<typeof request>[1] = {}) {
  return request<defs.store.HttpResponse>(`/storeapi/api/r/store/order/check`, {
    params,
    method: 'get',
    ...(config || {}),
  });
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.HttpResponse;
export default req;
